import { useEffect, useMemo } from 'react'
import { useRouter } from 'next/router'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import * as Cookies from 'js-cookie'
import { get } from 'lodash'

import { attemptLogin } from 'redux-web/utils/authentication/actions'
import { getAppRoute } from 'helpers/application'

const WithSignIn = WrapperComponent => {
  const Wrapper = props => {
    const router = useRouter()
    const { auth_token: authenticationToken } = router.query

    const dispatch = useDispatch()
    const loggedIn = useSelector(state => state.session.loggedIn)

    const application = useMemo(
      () => get(router, 'query.application'),
      [router]
    )

    useEffect(() => {
      if (authenticationToken) {
        dispatch(
          attemptLogin({ data: { authenticationToken: authenticationToken } })
        )
      }
    }, [])

    useEffect(() => {
      if (loggedIn) {
        const redirectTo = Cookies.get('citifyd_apple_login_redirect')

        if (redirectTo) {
          router.push(redirectTo)
        } else {
          router.push(
            `${getAppRoute(application, 'as')}/`,
            `${getAppRoute(application, 'url')}/`
          )
        }

        Cookies.remove('citifyd_apple_login_redirect')
      }
    }, [loggedIn])

    return <WrapperComponent {...props} />
  }

  if (WrapperComponent.getInitialProps) {
    Wrapper.getInitialProps = WrapperComponent.getInitialProps
  }

  Wrapper.propTypes = {
    authenticationToken: PropTypes.string,
    router: PropTypes.object,
  }

  return Wrapper
}

export default WithSignIn
